import { render } from "./database-tool.vue?vue&type=template&id=83c5db98&ts=true&lang=pug"
import script from "./database-tool.vue?vue&type=script&setup=true&lang=ts"
export * from "./database-tool.vue?vue&type=script&setup=true&lang=ts"

import "./database-tool.vue?vue&type=style&index=0&id=83c5db98&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__